import api from "../api/axiosConfig";
import {
  FinalDoctorRecommendation,
  FinalDoctorRecommendationFields,
  FinalRecommendationKey,
} from "../types/finalDoctorRecommendation";

const BASE = "/api/teledocs/final-doctor-recommendation";

export const FinalDoctorRecommendationService = {
  async get(
    emrId: string,
    chartType: string = "primary"
  ): Promise<FinalDoctorRecommendation> {
    const res = await api.dataCollectionApi.get(
      `${BASE}/${emrId}`,
      {
        params: {
          chartType,
        },
      }
    );

    return res.data.data;
  },

  async create(
    emrId: string,
    doctorName: string,
    chartType: string = "primary"
  ): Promise<FinalDoctorRecommendation> {
    const res = await api.dataCollectionApi.post(
      BASE,
      {
        emrId,
        doctorName,
        chartType,
        recommendation: {},
      }
    );

    return res.data.data;
  },

  async updateField(
    emrId: string,
    doctorName: string,
    field: FinalRecommendationKey,
    value: string,
    chartType: string = "primary"
  ): Promise<FinalDoctorRecommendation> {
    const res = await api.dataCollectionApi.patch(
      `${BASE}/${emrId}`,
      {
        doctorName,
        chartType,
        recommendation: {
          [field]: value,
        },
      }
    );

    return res.data.data;
  },

  async updateAll(
    emrId: string,
    doctorName: string,
    payload: Partial<FinalDoctorRecommendationFields>,
    chartType: string = "primary"
  ): Promise<FinalDoctorRecommendation> {
    const res = await api.dataCollectionApi.patch(
      `${BASE}/${emrId}`,
      {
        doctorName,
        chartType,
        recommendation: payload,
      }
    );

    return res.data.data;
  },
};